import { listUtils, type Optional } from '@festina-life/core'
import { useParams } from 'react-router'

import type { RoutableConfigurationItem } from '../types/common'
import type { AnyConfigurationRouteParams } from './types'

// Fails to compile when a routable configuration item is missing from the list
const CONFIGURATION_ITEMS_WITH_DEDICATED_VIEWER =
  listUtils.arrayOfAllUnique<RoutableConfigurationItem>()([
    'template',
    'parameterDefinition',
    'tenant',
    'enumDefinition',
    'glMap',
    'reconciliationSpec',
    'annulOperation',
  ])

const routeParameterForConfigurationItemInViewer = (
  type: RoutableConfigurationItem,
): keyof AnyConfigurationRouteParams => {
  switch (type) {
    case 'template':
      return 'templateId'
    case 'parameterDefinition':
      return 'parameterDefinitionId'
    case 'tenant':
      return 'registeredTenantId'
    case 'enumDefinition':
      return 'enumId'
    case 'glMap':
      return 'mappingId'
    case 'reconciliationSpec':
      return 'specId'
    case 'annulOperation':
      return 'annulOperationKey'
  }
}

export type CurrentConfigurationItem = {
  itemId: string
  type: RoutableConfigurationItem
}

export const useCurrentConfigurationItem =
  (): Optional<CurrentConfigurationItem> => {
    const params = useParams<AnyConfigurationRouteParams>()
    return CONFIGURATION_ITEMS_WITH_DEDICATED_VIEWER.map((type) => ({
      type,
      itemId: params[routeParameterForConfigurationItemInViewer(type)],
    })).find((value): value is CurrentConfigurationItem => !!value.itemId)
  }
